export const INDEX = 'index';
export const INDEX_3D = 'index3d';
export const EVENT_SWITCH_VIEW = 'switchView';

export const SCENE_INFO = [
    {
        load: false,
        id: 'software-park-A',
        name: '厦门集美软件园三期 A 区',
        url: 'https://xm.hightopo.net:7201/jimeiSoftwareParkA/tileset.json',
        position: {
            alt: 39.509242722908226,
            latitude: 24.615586145576092,
            longitude: 118.04179369520222,
        },
        adjustHeight:0,
    },
    {
        load: true,
        id: 'software-park-B',
        name: '厦门集美软件园三期 B 区',
        url: 'https://xm.hightopo.net:7201/jimeiSoftwareParkB/tileset.json',
        position: {
            alt: 1,
            latitude: 24.615586145576092,
            longitude: 118.04179369520222,
        },
        adjustHeight:15,
    },
    {
        load: false,
        id: 'software-park-C',
        name: '厦门集美软件园三期 C 区',
        url: 'https://xm.hightopo.net:7201/jimeiSoftwareParkC/tileset.json',
        position: {
            alt:15,
            latitude: 24.615586145576092,
            longitude: 118.04179369520222,
        },
        adjustHeight:15,
    }
];

// 场景初始化进场配置
export const ENTER_SCENE_CONFIG = [
    {
        heading: 345.1440217229497,
        height: 58672.12150772024,
        pitch: -89.99340759918461,
        position: [118.16797170699687, 24.554527722539483],
        roll: 0,
        animation: {
            duration: 8000,
        },
        delay:0
    },
    {
        heading: 339.32643262973465,
        height: 28923.94302030458,
        pitch: -29.76784929695376,
        position: [118.33242879186163, 24.107634084133718],
        roll: 0.0004992842667022046,
        animation: {
            duration: 2000,
            easingFunction: t => t
        },
        delay: 200
    },
    {
        // heading: 326.86514655994426,
        // height: 172.5150796622726,
        // pitch: -12.483206757176198,
        // position: [118.04442924090552, 24.612076889062436],
        // roll: 6.281763931035428,
        
        heading: 327.6416791984238,
        height: 166.79761521879848,
        pitch: -10.56553987862856,
        position: [118.04545726064303, 24.610496201216876],
        roll: 6.281803201842271,
        animation: {
            duration: 6000,
        },
        delay: 500
    }
];

// 场景初始化进场配置
export const BIM_SCENE_CONFIG = [
    {
        heading: 75.5461443028601,
        height: 66.56027905004746,
        pitch: -15.112138866833163,
        position: [118.04097450353149, 24.61586050733746],
        roll: 0.002546101443078541,
        animation: {
            duration: 4000,
            easingFunction: t => t
        },
        delay: 100
    },
    {
        heading: 172.6529761680937,
        height: 93.97181253329381,
        pitch: -30.14025542304705,
        position: [118.04207827815351, 24.617544489685493],
        roll: 0.0003747624346024381,
        animation: {
            duration: 4500,
            easingFunction: t => t
        },
        delay: 500
    },
    {
        heading: 251.04594214951834,
        height: 68.9230290801328,
        pitch: -14.360719225813954,
        position: [118.04381578935772, 24.616979791161878],
        roll: 6.280707974817311,
        animation: {
            duration: 4500,
            easingFunction: t => t
        },
        delay: 500
    },
    {
        heading: 323.6809974418304,
        height: 66.56696249897173,
        pitch: -12.482179120673695,
        position: [118.04341639936547, 24.615200263181993],
        roll: 6.281645064725872,
        animation: {
            duration: 4500,
            easingFunction: t => t
        },
        delay: 500
    },
    {
        heading: 45.673555720944975,
        height: 62.21943109408864,
        pitch: -10.227951955600874,
        position: [118.04124226500738, 24.61520822892959],
        roll: 0.0018454602026753975,
        animation: {
            duration: 4500,
            easingFunction: t => t
        },
        delay: 500
    }
];

// 园区漫游的配置 街道漫游，街道漫游，定位到金海豚，漫游金海豚，漫游到 Hightopo
export const ROAM_PATH_CONFIG = [
    // {
    //     heading: 327.65644867165685,
    //     height: 644.2484742882639,
    //     pitch: -11.711004760793676,
    //     position: [118.05311182300164, 24.600878948594563],
    //     roll: 6.281798656137882,
    //     animation: {
    //         duration: 4000,
    //         easingFunction: t => t
    //     }
    // },
    {
        heading: 327.6564486716568,
        height: 90,
        pitch: -11.711004760793651,
        position: [118.04505423901183, 24.611771128456045],
        roll: 6.281798656137882,
        animation: {
            duration: 5000,
            easingFunction: t => t
        }
    },
    {
        heading: 327.65645165093963,
        height: 90,
        pitch: -11.710982063916553,
        position: [118.03994917671433, 24.617891250929304],
        roll: 6.281798399957282,
        animation: {
            duration: 17000,
            easingFunction: t => t
        }
    },
    {
        heading: 327.6564516509397,
        height: 35,
        pitch: -11.710982063916553,
        position: [118.03867264290264, 24.61936495574756],
        roll: 6.281798399957282,
        animation: {
            duration: 6000,
            easingFunction: t => t
        }
    },
    {
        heading: 235.65149263774654,
        height: 60,
        pitch: -12.082316927142424,
        position: [118.0390885428021, 24.62027163148179],
        roll: 6.281042816241275,
        animation: {
            duration: 5000,
            easingFunction: t => t
        }
    },
    {
        heading: 142.21111874249561,
        height: 90,
        pitch: -20.25144094616271,
        position: [118.0360154975728, 24.618830878498123],
        roll: 0.0016565378636572703,
        animation: {
            duration: 12000,
            easingFunction: t => t
        }
    },
    {
        heading: 62.37331143037187,
        height: 100,
        pitch: -21.365396964625628,
        position: [118.03616853211575, 24.617614162063376],
        roll: 0.002415777863705948,
        animation: {
            duration: 4000,
            easingFunction: t => t
        }
    }
];

export const SUBSYSTEM_CAMERA = {
    elevatorSystem: {
        // heading: 76.88817517197457,
        // height: 130.46616332932246,
        // pitch: -10.06588493484276,
        // position: [118.03939923332165, 24.615122151287906],
        // roll: 0.002510636113476572,
        heading: 76.88817519421794,
        height: 171.31763169353192,
        pitch: -10.065884964029554,
        position: [118.0379306146151, 24.61481060217466],
        roll: 0.002510633892289782,
        animation: {
            duration: 2000
        }
    },
    lightSystem: {
        heading: 74.64279297829377,
        height: 168.62875850566493,
        pitch: -10.305607523225369,
        position: [118.03798887804325, 24.6147876175951],
        roll: 0.002487691058987273,
        animation: {
            duration: 2000
        }
    },
    fireFightingSystem: {
        heading: 56.64990866852107,
        height: 169.43656618466673,
        pitch: -13.112813960701875,
        position: [118.03838198667167, 24.61353346943886],
        roll: 0.0021774798789078176,
        animation: {
            duration: 2000
        }
    },
    securitySystem: {
        heading: 56.64990866852107,
        height: 169.43656618466673,
        pitch: -13.112813960701875,
        position: [118.03838198667167, 24.61353346943886],
        roll: 0.0021774798789078176,
        animation: {
            duration: 2000
        }
    },
    airConditioningSystem: {
        heading: 76.04325671602214,
        height: 841.8912769502024,
        pitch: -34.05637780345017,
        position: [118.02918345748537, 24.614386431779707],
        roll: 0.002974041973936359,
        animation: {
            duration: 2000
        }
    }
}